module.exports = __webpack_public_path__ + "static/bitss_logo-9da30e99cf2aad4d8959ea575292f8c7.png";